import { useState, useEffect } from 'react';

interface UseLocalStorageOptions<TValue> {
  parse?: (text: string) => TValue;
  stringify?: (value: TValue) => string;
}

export function useLocalStorage<TValue>(
  key: string,
  defaultValue: TValue,
  options: UseLocalStorageOptions<TValue> = {}
) {
  const { parse = JSON.parse, stringify = JSON.stringify } = options;

  const [state, setState] = useState<TValue>(() => {
    let value: TValue;
    try {
      value = parse(localStorage.getItem(key) || stringify(defaultValue));
    } catch {
      value = defaultValue;
    }
    return value;
  });

  useEffect(() => {
    localStorage.setItem(key, stringify(state));
  }, [key, state, stringify]);

  return [state, setState] as const;
}
